function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Marketing-collateral-genrator",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "hide",
  fill: "#717171"
}, React.createElement("path", {
  d: "M-1.13686838e-13,8.49997659 C-1.13686838e-13,13.1754519 3.90194318,17 8.66297727,17 L31.3370227,17 C36.1016761,17 40,13.1749836 40,8.49997659 C40,3.82498907 36.1016761,0 31.3370227,0 L8.66297727,0 C3.90194318,0 -1.13686838e-13,3.82452078 -1.13686838e-13,8.49997659 Z",
  id: "Shape",
  fillOpacity: 0.2
}), React.createElement("path", {
  d: "M8.49384491,3.17391304 C11.5187692,3.17391304 14,5.63878711 14,8.66774811 C14,11.6934644 11.5195951,14.173913 8.49384491,14.173913 C5.46483033,14.173913 3,11.6926778 3,8.66774811 C3,5.6395737 5.46565625,3.17391304 8.49384491,3.17391304 Z",
  id: "Path"
}), React.createElement("text", {
  fontFamily: "MavenPro-Regular, Maven Pro",
  fontSize: 7,
  fontWeight: "normal"
}, React.createElement("tspan", {
  x: 16,
  y: 11
}, "HIDE"))));

const SvgHidden = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "40px",
    height: "17px",
    viewBox: "0 0 40 17",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgHidden, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hidden.a61f7831.svg";
export { ForwardRef as ReactComponent };